import usePaginatedLogList from "../../../../hooks/usePaginatedLogList";
import LogListError from "../../../../components/LogListError";
import React, { useEffect, useState } from "react";
import { Button, Table, Space, Tooltip, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { EyeOutlined } from "@ant-design/icons";
import moment from "moment";

const { Option } = Select;

const ListCompanySupplyAndDischargeLog = () => {
  const navigate = useNavigate();
  const { data, loading, load: loadRecords, pagination, error, retry } =
    usePaginatedLogList(ApiURL.company_supply_and_discharge, "data");
  const [filter, setFilter] = useState("all");

  const [shipList, setShipList] = useState([]);
  const [shipId, setShipId] = useState("");

  const fetchShipTableList = async () => {
    const res = await post(ApiURL.list_ships_view_com, new FormData());
    if (res?.status && res.ships?.length) {
      setShipList(res.ships);
      setShipId(res.ships[0].id);
    }
  };

  const LIST_API = (selectedFilter = filter, selectedShip = shipId) => {
    if (!selectedShip) return;
    return loadRecords({ ship_id: selectedShip, ...(selectedFilter !== "all" ? { filter: selectedFilter } : {}) });
  };

  useEffect(() => {
    fetchShipTableList();
  }, []);

  useEffect(() => {
    if (shipId) LIST_API();
  }, [shipId]);

  const handleFilterChange = (value) => {
    setFilter(value);
    LIST_API(value, shipId);
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      align: "center",
      render: (date) => (date ? moment(date).format("DD-MM-YYYY") : "-"),
    },
    { title: "Supply (kg)", dataIndex: "supply_of_ods_kgs", align: "center" },
    { title: "Deliberate Discharge", dataIndex: "deliberate_discharge_kgs", align: "center" },
    { title: "Non-Deliberate Discharge", dataIndex: "non_deliberate_discharge_kgs", align: "center" },
    { title: "Shore Discharge", dataIndex: "discharge_to_shore_kgs", align: "center" },
    { title: "Remarks", dataIndex: "remarks", align: "center" },
    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="View Record">
          <EyeOutlined
            style={{ fontSize: 18, color: "#1677ff", cursor: "pointer" }}
            onClick={() =>
              navigate(`/view-supply-and-discharge-log/${record?.id}`)
            }
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h2>Supply and Discharge Log</h2>

        <Space>
          <Select
            value={shipId}
            style={{ width: 220 }}
            onChange={(value) => {
              setShipId(value);
            }}
          >
            {shipList.map((ship) => (
              <Option key={ship.id} value={ship.id}>
                {ship.vessel_name}
              </Option>
            ))}
          </Select>

          <Button type={filter === "all" ? "primary" : "default"} onClick={() => handleFilterChange("all")}>
            All
          </Button>
          <Button type={filter === "pending" ? "primary" : "default"} onClick={() => handleFilterChange("pending")}>
            Pending
          </Button>
          <Button type={filter === "approved" ? "primary" : "default"} onClick={() => handleFilterChange("approved")}>
            Approved
          </Button>

        </Space>
      </div>

      <LogListError error={error} retry={retry} />
      <Table
        pagination={pagination}
        bordered
        loading={loading}
        columns={columns}
        dataSource={data}
        rowKey="id"
        className="custom-table"
      />
    </>
  );
};

export default ListCompanySupplyAndDischargeLog;
